import { css } from '@emotion/react'
import { useState } from 'react'
import { inject, Observer } from 'mobx-react'
import { withRouterProps } from '../../../utils'
import { Loading } from '../../../components'
import MultiLineButton from '../../../components/MultiLineButton'
import { ButtonGroup } from '../elements/styled'

// TO-DO: Change managed account text to point-in-time advice based on templateId
function ValuePropButtons({ navigate, store, offboarding }) {
  const [state, setState] = useState('idle')

  // Do this check in case they get to this page through the back button when they're already a managedAccount
  if (store.account.managedAccount) {
    handleNext()
  }

  function handleNext() {
    navigate(`/implement/${offboarding.nextRoute('value-proposition')}`)
  }

  async function acceptManagedAccount() {
    try {
      setState('loading')

      await store.updateManagedAccountStatus({
        managedAccountStatus: true,
        caseId: store.acceptedCaseId,
        savingsRateTransactionOptional: store.acceptedContributionDistribution.catchUp
          ? store.acceptedContributionDistribution
          : null,
      })

      offboarding.setAcceptedCaseSubmitted(true)

      handleNext()
    } catch (err) {
      console.error(err)
      setState('error')
    }
  }

  function render() {
    if (state === 'loading') {
      return (
        <ButtonGroup>
          <Loading />
        </ButtonGroup>
      )
    }

    const { features } = store

    return (
      <div>
        {state === 'error' && (
          <div
            css={css`
              color: crimson;
              text-align: center;
            `}>
            Oops! Something went wrong, please try again later
          </div>
        )}
        <ButtonGroup>
          <MultiLineButton
            variant='secondary'
            label='Cancel'
            sublabel={
              <>
                no action | return to
                <br />
                Home
              </>
            }
            onClick={() => navigate('/overall')}
          />

          {features.viewAdviceOnlyEnabled && (
            <MultiLineButton
              variant='tertiary'
              label='View advice only'
              sublabel={
                <>
                  no implementation | no ongoing
                  <br />
                  review | no guide
                </>
              }
              onClick={handleNext}
            />
          )}

          {features.oneTimeAdviceEnabled && (
            <MultiLineButton
              variant='tertiary'
              label='Implement one-time advice'
              sublabel={
                <>
                  single use option over life of
                  <br />
                  account | no ongoing review
                </>
              }
              onClick={handleNext}
            />
          )}

          {features.managedAccountAvailable && (
            <MultiLineButton
              label='Accept managed account'
              sublabel={
                <>
                  implement | ongoing
                  <br />
                  quarterly review
                </>
              }
              onClick={() => acceptManagedAccount()}
            />
          )}
        </ButtonGroup>
      </div>
    )
  }

  return <Observer>{render}</Observer>
}

export default withRouterProps(inject('store', 'offboarding')(ValuePropButtons))
